import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { SavedCartDetailsItemsComponent, SavedCartDetailsService } from '@spartacus/cart/saved-cart/components';
import { SavedCartFacade } from '@spartacus/cart/saved-cart/root';
import {
    EventService,
    GlobalMessageService,
    GlobalMessageType,
    RoutingService,
    TranslationService,
    User
} from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { Observable, Subscription } from 'rxjs';
import { filter, map, mapTo, take, tap } from 'rxjs/operators';
import {Cart, CartItemComponentOptions, DeleteCartSuccessEvent} from '@spartacus/cart/base/root';
import { UigCartGroupingService } from '../../../uig-cart-grouping/uig-cart-grouping.service';

@Component({
    selector: 'app-uig-saved-cart-details-items',
    templateUrl: './uig-saved-cart-details-items.component.html',
    styleUrls: ['./uig-saved-cart-details-items.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UigSavedCartDetailsItemsComponent extends SavedCartDetailsItemsComponent implements OnInit {
  
  private sub = new Subscription();
  isRestricted: boolean = false;
  RIO_CART_ORDER: string = "rio_cart_order";
  RIO_CART_CREATE_UPDATE: string = "rio_cart_create_update";
  private userSubscription = new Subscription();  
  vendorEntryGroups$: Observable<any[]>;

  savedCart$: Observable<
    Cart | undefined
  > = this.savedCartDetailsService.getCartDetails().pipe(
    tap((cart) => {
      if ((cart?.entries ?? []).length <= 0 && !!cart?.code) {
        this.globalMessageService.add(
          {
            key: 'customSavedCartDialog.emptyCart',
          },
          GlobalMessageType.MSG_TYPE_WARNING
        );
      }
    })
  );
  
  @Input() options: CartItemComponentOptions = {
    isSaveForLater: false,
    optionalBtn: null,
  };

  constructor(
    protected savedCartDetailsService: SavedCartDetailsService,
    protected savedCartService: SavedCartFacade,
    protected eventSercvice: EventService,
    protected globalMessageService: GlobalMessageService,
    protected routingService: RoutingService,
    protected userAccountFacade: UserAccountFacade,
    protected translationService: TranslationService,
    protected uigCartGroupingService: UigCartGroupingService
  ) {
    super(savedCartDetailsService, savedCartService, eventSercvice, globalMessageService, routingService, translationService);
   }

   ngOnInit(): void {
    this.checkForRoles();
    this.sub.add(
      this.eventSercvice
        .get(DeleteCartSuccessEvent)
        .pipe(take(1), mapTo(true))
        .subscribe((success) => this.onDeleteComplete(success))
    );
    this.vendorEntryGroups$ = this.savedCart$.pipe(map((cart) => {
      return this.uigCartGroupingService.groupByVendor(cart.entries, cart.groupSums);
    }))
  }

  onDeleteComplete(success: boolean): void {
    if (success) {
      this.routingService.go({ cxRoute: 'savedCarts' });
      this.globalMessageService.add(
        {
          key: 'customSavedCartDialog.deleteCartSuccess',
        },
        GlobalMessageType.MSG_TYPE_CONFIRMATION
      );
    }
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
    this.userSubscription.unsubscribe();
  }

  checkForRoles() {
    this.userSubscription = this.userAccountFacade
      .get()
      .pipe(filter((user: User) => user && Object.keys(user).length > 0))
      .subscribe((user) => {
        const hasRole =
          user.roles && (user.roles.includes(this.RIO_CART_CREATE_UPDATE)
            || user.roles.includes(this.RIO_CART_ORDER));
        if (!hasRole) {
          this.isRestricted = true;
        }
      });
  }
}
